export default "__VITE_ASSET__CPeOY1sz__"